(function () {
  'use strict';

  // Only run on collection pages.
  if (!document.querySelector('.product-grid-container')) return;

  var processedElements = new WeakSet();
  var productCache = {};
  var queue = [];
  var active = 0;
  var MAX_CONCURRENT = 2;
  var observer = null;

  function keepOnlyVariantSlide(clone, imageId, imgSrc) {
    var slides = Array.prototype.slice.call(clone.querySelectorAll('slideshow-slide'));
    if (slides.length <= 1) return;

    var targetSlide = null;

    if (imageId) {
      var idStr = String(imageId);
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('slide-id') === idStr) {
          targetSlide = slides[i];
          break;
        }
      }
    }

    if (!targetSlide && imageId) {
      var mediaDiv = clone.querySelector('[data-media-id="' + String(imageId) + '"]');
      if (mediaDiv) {
        var el = mediaDiv;
        while (el && el !== clone) {
          if (el.tagName && el.tagName.toLowerCase() === 'slideshow-slide') {
            targetSlide = el;
            break;
          }
          el = el.parentElement;
        }
      }
    }

    if (!targetSlide && imgSrc) {
      var rawFile = imgSrc.split('?')[0].split('/').pop();
      var fname = rawFile.replace(/_\d+x\d*(\.[^.]+)$/i, '$1');
      if (fname) {
        for (var j = 0; j < slides.length; j++) {
          var imgs = slides[j].querySelectorAll('img');
          for (var k = 0; k < imgs.length; k++) {
            var hay = [
              imgs[k].getAttribute('src') || '',
              imgs[k].getAttribute('srcset') || '',
              imgs[k].getAttribute('data-src') || '',
              imgs[k].getAttribute('data-srcset') || ''
            ].join(' ');
            if (hay.indexOf(fname) !== -1) {
              targetSlide = slides[j];
              break;
            }
          }
          if (targetSlide) break;
        }
      }
    }

    if (!targetSlide) return;

    for (var n = 0; n < slides.length; n++) {
      if (slides[n] !== targetSlide && slides[n].parentNode) {
        slides[n].parentNode.removeChild(slides[n]);
      }
    }

    targetSlide.removeAttribute('hidden');
    targetSlide.setAttribute('aria-hidden', 'false');
  }

  function expandLi(li, product) {
    if (!li || !li.parentElement || !product || !product.variants || product.variants.length <= 1) return;

    var seenImageIds = {};
    var validVariants = product.variants.filter(function (variant) {
      if (!variant.featured_image || !variant.featured_image.src) return false;
      if (seenImageIds[variant.featured_image.id]) return false;
      seenImageIds[variant.featured_image.id] = true;
      return true;
    });

    if (validVariants.length <= 1) return;

    var parent = li.parentElement;
    var insertBefore = li.nextSibling;
    // 2026-10-19：第一个颜色留在原位，其余颜色每隔 STRIDE 张卡插一张，同款不再连排
    var STRIDE = 6;
    var anchors = [];
    var walker = li.nextElementSibling;
    for (var k = 1; walker; k++) {
      if (k % STRIDE === 0) anchors.push(walker);
      walker = walker.nextElementSibling;
    }

    for (var i = 0; i < validVariants.length; i++) {
      if (i > 0) insertBefore = anchors[i - 1] || null;
      var variant = validVariants[i];
      var clone = li.cloneNode(true);
      clone.removeAttribute('id');
      clone.setAttribute('data-variant-id', String(variant.id));
      clone.removeAttribute('data-product-handle');

      var variantUrl = '/products/' + product.handle + '?variant=' + variant.id;
      var galleryLink = clone.querySelector('[ref="cardGalleryLink"]');
      if (galleryLink) galleryLink.href = variantUrl;

      var cardLink = clone.querySelector('a.product-card__link');
      if (cardLink) cardLink.href = variantUrl;

      var productCard = clone.querySelector('product-card');
      if (productCard) productCard.setAttribute('data-featured-media-url', variant.featured_image.src);

      keepOnlyVariantSlide(clone, variant.featured_image.id, variant.featured_image.src);
      parent.insertBefore(clone, insertBefore);
    }

    li.remove();
  }

  function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];

    productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('HTTP ' + response.status);
        }
        return response.text();
      })
      .then(function (text) {
        try {
          return JSON.parse(text);
        } catch (e) {
          throw new Error('Invalid product JSON');
        }
      })
      .catch(function () {
        delete productCache[handle];
        return null;
      });

    return productCache[handle];
  }

  function drainQueue() {
    while (active < MAX_CONCURRENT && queue.length) {
      var li = queue.shift();
      if (!li || !li.parentElement) continue;

      active += 1;
      processCard(li).then(function () {
        active -= 1;
        drainQueue();
      });
    }
  }

  function enqueue(li) {
    if (!li || processedElements.has(li)) return;
    processedElements.add(li);
    queue.push(li);
    drainQueue();
  }

  function processCard(li) {
    var handle = li.getAttribute('data-product-handle');
    if (!handle) return Promise.resolve();

    return fetchProduct(handle).then(function (product) {
      if (product) expandLi(li, product);
    });
  }

  function observeCard(li) {
    if (!li || processedElements.has(li)) return;
    if (!observer) {
      enqueue(li);
      return;
    }
    observer.observe(li);
  }

  function observeAll(root) {
    var items = (root || document).querySelectorAll('li[data-product-handle]');
    for (var i = 0; i < items.length; i++) observeCard(items[i]);
  }

  function init() {
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          observer.unobserve(entries[i].target);
          enqueue(entries[i].target);
        }
      }, { rootMargin: '700px 0px' });
    }

    observeAll(document);

    var grid = document.querySelector('ul.product-grid');
    var container = document.querySelector('.product-grid-container');
    var mutationRoot = grid || container;
    if (!mutationRoot) return;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('li[data-product-handle]')) observeCard(node);
          if (node.querySelectorAll) observeAll(node);
        }
      }
    }).observe(mutationRoot, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
